define('js/views/ClockView',[
    'js/lib/checkRequiredOptions',
    'vendor/luxon'
], function (
    checkRequiredOptions,
    luxon
) {
    'use strict';

    function domNode() {
        var node = document.createElement('div');
        node.className = 'sceneHeader__clock';
        return node;
    }

    function formatForClock(timezone) {
        const dt = luxon.DateTime.local().setZone(timezone);

        return `${dt.toFormat('HH:mm')} ${dt.offsetNameShort}`;
    }

    function ClockView(options) {
        checkRequiredOptions('ClockView', ['timezone', 'locale'], options);
        this.timezone = options.timezone;
        this.locale = options.locale;
        this.el = domNode();
    }

    ClockView.prototype.render = function render() {
        var view = this;
        var lastUpdate = 0;

        function loop(delta) {
            view.timer = requestAnimationFrame(loop);
            if (delta - lastUpdate > 1000) {
                view.el.textContent = formatForClock(view.timezone);
                lastUpdate = delta;
            }
        }
        view.timer = requestAnimationFrame(loop);

        this.el.textContent = formatForClock(this.timezone);
    };

    ClockView.prototype.remove = function remove() {
        cancelAnimationFrame(this.timer);
        this.el.remove();
    };

    return ClockView;
});
